export default __webpack_public_path__ + "media/shipment/matkahuolto-43403099.svg";